import { ChainAvatar } from '@/ui/Avatars/ChainAvatar';

import { CompletedTradeRow } from '../types';

export function CompletedTradeNetworkCell({ row }: { row: CompletedTradeRow }) {
  const { originChainId, originNetworkName, destinationChainId, destinationNetworkName } = row;
  return (
    <span className="flex items-center">
      <ChainAvatar
        chainId={originChainId}
        alt={`${originNetworkName ?? 'Unknown network'} logo`}
        size={16}
        className="mr-1"
      />
      {originNetworkName ?? 'Unknown network'}
      {destinationChainId && destinationNetworkName && (
        <>
          <span className="mx-2">→</span>
          <ChainAvatar
            chainId={destinationChainId}
            alt={`${destinationNetworkName} logo`}
            size={16}
            className="mr-1"
          />
          {destinationNetworkName}
        </>
      )}
    </span>
  );
}
